/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutTaskNotificationPhase } from './rolloutTaskNotificationPhase';
import { ScheduledNotificationBefore } from './scheduledNotificationBefore';


export interface RolloutNotificationSpec { 
    /**
     * Name of the notification.
     */
    name: string;
    /**
     * Whether the notification is enabled.
     */
    enabled: boolean;
    phase: RolloutTaskNotificationPhase;
    /**
     * List of triggers for the notification only applicable for SCHEDULED notifications.
     */
    triggers?: Array<ScheduledNotificationBefore>;
}
export namespace RolloutNotificationSpec {
}


